import {INotification} from "@pg-design/notifications";

import {ERROR_NOTIFICATIONS_CONTENT} from "../constants/error_notifications_content";

const {COOKIE_BOT, DEFAULT_API, PHONE} = ERROR_NOTIFICATIONS_CONTENT;

export const defaultAPIErrorNotification: Pick<INotification, "type" | "content"> = {type: "failure", content: DEFAULT_API};
export const phoneErrorNotification: Pick<INotification, "type" | "content"> = {type: "failure", content: PHONE};
export const cookieBotErrorNotification: Pick<INotification, "type" | "content"> = {type: "failure", content: COOKIE_BOT};
import {INotification} from "@pg-design/notifications";

import {ERROR_NOTIFICATIONS_CONTENT} from "../constants/error_notifications_content";

const {COOKIE_BOT, DEFAULT_API, PHONE} = ERROR_NOTIFICATIONS_CONTENT;

export const defaultAPIErrorNotification: Pick<INotification, "type" | "content"> = {type: "failure", content: DEFAULT_API};
export const phoneErrorNotification: Pick<INotification, "type" | "content"> = {type: "failure", content: PHONE};
export const cookieBotErrorNotification: Pick<INotification, "type" | "content"> = {type: "failure", content: COOKIE_BOT};
